export var PlayerAdapterEvent;
(function (PlayerAdapterEvent) {
    PlayerAdapterEvent["ACTIVE_STATE_CHANGE"] = "activestatechange";
    PlayerAdapterEvent["AD_BREAK_COMPLETE"] = "adbreakcomplete";
    PlayerAdapterEvent["AD_BREAK_DISCARDED"] = "adbreakdiscarded";
    PlayerAdapterEvent["AD_BREAK_METADATA"] = "adbreakmetadata";
    PlayerAdapterEvent["AD_BREAK_START"] = "adbreakstart";
    PlayerAdapterEvent["AD_CLICK"] = "adclick";
    PlayerAdapterEvent["AD_COMPLETE"] = "adcomplete";
    PlayerAdapterEvent["AD_CUEPOINTS_AVAILABLE"] = "adcuepointsavailable";
    PlayerAdapterEvent["AD_FIRST_QUARTILE"] = "adfirstquartile";
    PlayerAdapterEvent["AD_MIDPOINT"] = "admidpoint";
    PlayerAdapterEvent["AD_PAUSED"] = "adpaused";
    PlayerAdapterEvent["AD_PLAYING"] = "adplaying";
    PlayerAdapterEvent["AD_PROGRESS"] = "adprogress";
    PlayerAdapterEvent["AD_SEGMENT_END"] = "adsegmentend";
    PlayerAdapterEvent["AD_SEGMENT_REENTERED"] = "adsegmentreentered";
    PlayerAdapterEvent["AD_SEGMENT_START"] = "adsegmentstart";
    PlayerAdapterEvent["AD_SKIPPABLE_STATE_CHANGE"] = "adskippablestatechange";
    PlayerAdapterEvent["AD_SKIPPED"] = "adskipped";
    PlayerAdapterEvent["AD_STALLED"] = "adstalled";
    PlayerAdapterEvent["AD_START"] = "adstart";
    PlayerAdapterEvent["AD_THIRD_QUARTILE"] = "adthirdquartile";
    PlayerAdapterEvent["AUDIO_TRACK_CHANGE"] = "audiotrackchange";
    PlayerAdapterEvent["AUDIO_TRACKS_CHANGE"] = "audiotrackschange";
    PlayerAdapterEvent["AUTOPLAY_BLOCKED"] = "autoplayblocked";
    PlayerAdapterEvent["CDN_CHANGE"] = "cdnchange";
    PlayerAdapterEvent["CLOCK"] = "aviaclock";
    PlayerAdapterEvent["CONTENT_COMPLETE"] = "contentcomplete";
    PlayerAdapterEvent["CONTENT_DURATION_AVAILABLE"] = "contentdurationavailable";
    PlayerAdapterEvent["CONTENT_IS_PLAYING_LIVE"] = "contentisplayinglive";
    PlayerAdapterEvent["CONTENT_PAUSED"] = "contentpaused";
    PlayerAdapterEvent["CONTENT_PLAYING"] = "contentplaying";
    PlayerAdapterEvent["CONTENT_PROGRESS"] = "contentprogress";
    PlayerAdapterEvent["CONTENT_SEGMENT_END"] = "contentsegmentend";
    PlayerAdapterEvent["CONTENT_SEGMENT_START"] = "contentsegmentstart";
    PlayerAdapterEvent["CONTENT_START"] = "contentstart";
    PlayerAdapterEvent["DRM_KEY_SYSTEM_CREATED"] = "drmkeysystemcreated";
    PlayerAdapterEvent["ERROR"] = "error";
    PlayerAdapterEvent["FULLSCREEN_CHANGE"] = "fullscreenchange";
    PlayerAdapterEvent["LANGUAGE_CHANGE"] = "languagechange";
    PlayerAdapterEvent["LIVE_PRESENTATION_STOPPED"] = "livepresentationstopped";
    PlayerAdapterEvent["LOG_EVENT"] = "logevent";
    PlayerAdapterEvent["METADATA_CUEPOINT"] = "metadatacuepoint";
    PlayerAdapterEvent["METRIC"] = "metric";
    PlayerAdapterEvent["MUTE_CHANGE"] = "mutechange";
    PlayerAdapterEvent["PLAYBACK_RESUMED"] = "playbackresumed";
    PlayerAdapterEvent["PLAYBACK_STARTED"] = "playbackstarted";
    PlayerAdapterEvent["PLAYBACK_STATE_CHANGE"] = "playbackstatechange";
    PlayerAdapterEvent["PLAYBACK_SUSPENDED"] = "playbacksuspended";
    PlayerAdapterEvent["PLUGIN_EVENT"] = "pluginevent";
    PlayerAdapterEvent["PRESENTATION_SIZE_CHANGE"] = "presentationsizechange";
    PlayerAdapterEvent["QUALITIES_CHANGE"] = "qualitieschange";
    PlayerAdapterEvent["QUALITY_CHANGE"] = "qualitychange";
    PlayerAdapterEvent["READY"] = "ready";
    PlayerAdapterEvent["RESOURCE_BUFFERING"] = "resourcebuffering";
    PlayerAdapterEvent["RESOURCE_END"] = "resourceend";
    PlayerAdapterEvent["RESOURCE_START"] = "resourcestart";
    PlayerAdapterEvent["SEEK_COMPLETE"] = "seekcomplete";
    PlayerAdapterEvent["SEEK_REDIRECT_COMPLETE"] = "seekredirectcomplete";
    PlayerAdapterEvent["SEEK_REDIRECT_START"] = "seekredirectstart";
    PlayerAdapterEvent["SEEK_START"] = "seekstart";
    PlayerAdapterEvent["STREAM_ID_AVAILABLE"] = "streamidavailable";
    PlayerAdapterEvent["STREAM_METADATA"] = "streammetadata";
    PlayerAdapterEvent["STREAM_TYPE_CHANGE"] = "streamtypechange";
    PlayerAdapterEvent["TEXT_CUEPOINT"] = "textcuepoint";
    PlayerAdapterEvent["TEXT_TRACK_AVAILABLE"] = "texttrackavailable";
    PlayerAdapterEvent["TEXT_TRACK_CHANGE"] = "texttrackchange";
    PlayerAdapterEvent["TEXT_TRACK_ENABLED_CHANGE"] = "texttrackenabledchange";
    PlayerAdapterEvent["TEXT_TRACKS_CHANGE"] = "texttrackschange";
    PlayerAdapterEvent["THUMBNAIL_TRACK_AVAILABLE"] = "thumbnailtrackavailable";
    PlayerAdapterEvent["VIDEO_ELEMENT_ADDED"] = "videoelementadded";
    PlayerAdapterEvent["VIDEO_ELEMENT_REMOVED"] = "videoelementremoved";
    PlayerAdapterEvent["VOLUME_CHANGE"] = "volumechange";
    PlayerAdapterEvent["WAITING_CHANGE"] = "waitingchange";
})(PlayerAdapterEvent || (PlayerAdapterEvent = {}));
